export default __webpack_public_path__ + "static/media/debit-note.4b87049b.svg";